<div style="font-size: 15px; font-weight: 500;">
  {{title}}
  <mat-divider [ngStyle]="{'width': '90%'}" [ngStyle.lt-lg]="{'width': '100%'}"></mat-divider>
</div>
<mat-list class="file-list"
  [ngStyle]="{'width': '90%'}"
  [ngStyle.lt-lg]="{'width': '100%'}"
  [ngStyle.lt-md]="{'margin-bottom': '28x'}">

  <mat-list-item
    *ngFor="let item of taskList">

    <div matLine
      style="display: inline-block !important; width: 100%;"
      [ngStyle.gt-sm]="{'margin-bottom': '12px'}"
      [ngStyle.lt-md]="{'margin-bottom': '36px'}">
      <div fxLayout="row" fxLayout.lt-md="column wrap"
        [ngStyle.gt-sm]="{'margin-top': '9px'}">
        <div fxFlex='70%' [ngStyle.lt-md]="{'width': '100%'}">

          <div class="text-ellipsis" [title]="item.name"
            style="font-size: 18px; font-weight: 400;">
            {{item.name}}
          </div>

          <div [ngSwitch]="item.statusCode">
            <div *ngSwitchCase="700000000" style="font-size: 14px; font-weight: 400;">
              Waiting for upload
            </div>
            <div *ngSwitchCase="700000002" style="white-space: normal;">
              <span class="warn-text">
                Action required
              </span>
              <span style="white-space:nowrap;">
                (<a style='color: #29637C; font-size: 16px; font-weight: 400;'
                  href="javascript:void(0)"
                   (click)='onClickShowReasonWhy(item.reasonWhy)'>read why</a>)
              </span>
            </div>
            <div *ngSwitchDefault style="font-size: 14px; font-weight: 400;">
              {{item.statusCodeOptionSet}}
            </div>
          </div>

        </div>

        <div fxFlex='46%'>
          <div
            *ngIf="(checkUploadAuthorization(item) === 1 || checkUploadAuthorization(item) === 2)
                    else displayFileItemAction">
            <div
              *ngIf="checkUploadAuthorization(item) === 1 && item.statusCode !== 700000001"
              style="color: #707070; font-size: 14px; text-transform: uppercase;"
              [ngStyle]="{'float': 'right', 'margin-top': '14px'}"
              ngStyle.lt-md="{'float': 'left', 'margin-top': '14px'}">
              SUBMITTED
            </div>
            <div
              *ngIf="checkUploadAuthorization(item) === 1 && item.statusCode === 700000001"
              style="color: #707070; font-size: 14px; text-transform: uppercase;"
              [ngStyle]="{'float': 'right', 'margin-top': '14px'}"
              ngStyle.lt-md="{'float': 'left', 'margin-top': '14px'}">
              APPROVED
            </div>
            <div
              *ngIf="checkUploadAuthorization(item) === 2"
              style="color: #707070; font-size: 14px; text-transform: uppercase;"
              [ngStyle]="{'float': 'right', 'margin-top': '14px'}"
              ngStyle.lt-md="{'float': 'left', 'margin-top': '14px'}">
              READ-ONLY
            </div>
          </div>
          <ng-template #displayFileItemAction>
            <div
              [ngStyle.gt-sm]="{'float': 'right'}"
              [ngStyle.lt-md]="{'margin-top': '12px'}">
              <button
                *ngIf="item.fileList.length > 0" 
                id="{{formatNameToId(item.name)}}-attachanother"
                mat-stroked-button color="primary"
                style="text-transform: uppercase;"
                (click)="onUploadFileEvent(null, item.id, item.typeCodeOptionSet, item.name)">
                <mat-icon>add</mat-icon>
                ATTACH ANOTHER FILE
              </button>
              <br *ngIf="item.statusCode === 700000002 && item.fileList.length > 0 && innerWidth < 500"/>
              <button
                *ngIf="item.statusCode === 700000002 && item.fileList.length > 0 && innerWidth < 500"
                mat-flat-button color="primary" 
                id="{{formatNameToId(item.name)}}-saveupdates"
                style="margin-top: 12px; text-transform: uppercase;"
                (click)="onSaveRejectedTaskItem(item.id)">
                SAVE UPDATES
              </button>
              <button
                *ngIf="item.statusCode === 700000002 && item.fileList.length > 0 && innerWidth >= 500"
                mat-flat-button color="primary" 
                id="{{formatNameToId(item.name)}}-saveupdates"
                style="margin-left: 9px; text-transform: uppercase;"
                (click)="onSaveRejectedTaskItem(item.id)">
                SAVE UPDATES
              </button>
              <button
                *ngIf="item.fileList.length === 0"
                mat-flat-button color="primary" 
                id="{{formatNameToId(item.name)}}-upload"
                style="text-transform: uppercase;"
                (click)="onUploadFileEvent(null, item.id, item.typeCodeOptionSet, item.name)">
                UPLOAD FILE
              </button>
            </div>
          </ng-template>
        </div>
      </div>

      <div *ngFor="let file of item.fileList" style="margin-top: 15px;">
        <div style="min-height: 28px; border-radius: 9px; background-color: #F3F3F3;" ngStyle.gt-sm="{'max-height': '32px'}">
          <div fxLayout="row" fxLayout.lt-md="column wrap"
            [ngStyle.gt-sm]="{'margin-top': '9px'}"
            [ngStyle.lt-md]="{'margin-top': '36px'}">
            <div fxFlex='70%'>
              <div fxFlex="10%" style="margin-left: 6px; margin-top: 9px;">
                <mat-icon style="font-size: 16px;" >attach_file</mat-icon>
                </div>
                <div fxFlex="90%" style="margin-left: 6px; margin-top: 9px;">
                <a *ngIf='item.statusCode !== 700000000'
                  title="{{file.payloadName}}" href="javascript:void(0)"
                  style="color: #29637C; font-size: 16px; font-weight: 400; margin-left: 3px;"
                  (click)="onViewFileEvent(file.payloadId, file.payloadName)">
                  {{file.payloadName | Filename}}
                </a>
              </div>
            </div>
            <div fxFlex='30%'>
              <div [ngClass]="'buttonAlignContainer'"
                [ngStyle.gt-sm]="{'float': 'right'}" style="margin-top: 6px; margin-left: 6px;">
                <button *ngIf="file.ebbModifiedByTypeOptionSet && file.ebbModifiedDate"
                  matTooltip="{{file.ebbModifiedByTypeOptionSet}} Update, Date: {{file.ebbModifiedDate | date:'MM/dd/yyyy':'PST'}}"
                  mat-icon-button color="primary" aria-label="information"
                  style="margin-right: 6px;">
                  <mat-icon style="font-size: 24px; margin-top: -18px;">info</mat-icon>
                </button>
                <button matTooltip="Replace"
                  *ngIf="checkUploadAuthorization(item) === 3"
                  mat-icon-button color="accent" aria-label="Replace file"
                  style="margin-right: 6px;"
                  (click)="onUploadFileEvent(file.payloadId, item.id, item.typeCodeOptionSet, item.name)">
                  <mat-icon style="font-size: 24px; margin-top: -18px;">edit</mat-icon>
                </button>
                <button matTooltip="Delete"
                  *ngIf="checkUploadAuthorization(item) === 3"
                  mat-icon-button color="warn" aria-label="Delete file"
                  style="margin-right: 6px;"
                  (click)="onDeleteFileEvent(file.payloadId, file.payloadName, item.id)">
                  <mat-icon style="font-size: 24px; margin-top: -18px;">delete_forever</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <mat-divider fxShow ></mat-divider>
  </mat-list-item>

  <div *ngIf="autoSaveIndicator" style="margin-top: 12px;">
    <mat-progress-bar mode="indeterminate" style="width: 300px;"></mat-progress-bar>
  </div>

</mat-list>
